import { actionCreator } from 'utils';
import * as ProductGroupTypes from '../types/productGroupTypes';

// L O A D   P R O D U C T   G R O U P S   W I T H   P A G I N A T I O N   &   S O R T
export function loadProductGroups() {
    return {
        type: ProductGroupTypes.LOAD_PRODUCT_GROUPS,
    };
}

export function loadProductGroupsRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUPS, 'res'),
        data,
    };
}

export function loadProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUPS, 'err'),
    };
}

export function setProductGroupsPagination(key, pagination) {
    return {
        type: ProductGroupTypes.SET_PRODUCT_GROUPS_PAGINATION,
        key,
        pagination,
    };
}

export function setProductGroupsSort(sort) {
    return {
        type: ProductGroupTypes.SET_PRODUCT_GROUPS_SORT,
        sort,
    };
}

export function resetProductGroupsFilters() {
    return {
        type: ProductGroupTypes.RESET_PRODUCTS_GROUPS_FILTERS,
    };
}
// L O A D   P R O D U C T   G R O U P S   W I T H   P A G I N A T I O N   &   S O R T


// S E T   P R O D U C T   G R O U P S   F I L T E R
export function setProductGroupsFilters(key, value) {
    return {
        type: ProductGroupTypes.SET_PRODUCT_GROUPS_FILTER,
        key,
        value,
    };
}

export function setProductGroupsFiltersRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.SET_PRODUCT_GROUPS_FILTER, 'res'),
        data,
    };
}
// S E T   P R O D U C T   G R O U P S   F I L T E R

// T O G G L E   P R O D U C T   G R O U P S   S T A T U S
export function toggleProductGroupsStatus(id, status) {
    return {
        type: ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS,
        id,
        status,
    };
}

export function toggleProductGroupsStatusRes() {
    return {
        type: actionCreator(ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS, 'res'),
    };
}

export function toggleProductGroupsStatusErr() {
    return {
        type: actionCreator(ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS, 'err'),
    };
}
// T O G G L E   P R O D U C T   G R O U P S   S T A T U S


// S E T   P R O D U C T   G R O U P S   C O N F I G U R A T I O N
export function setCheckedProductGroups(ids) {
    return {
        type: ProductGroupTypes.SET_CHECKED_GROUPS_STATUS,
        ids,
    };
}
// S E T   P R O D U C T   G R O U P S   C O N F I G U R A T I O N


// B U L K   P R O D U C T   G R O U P S   P R O D U C T S  G R O U P S
export function bulkCheckedProductGroups(ids, bulk) {
    return {
        type: ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS,
        bulk,
        ids,
    };
}

export function bulkCheckedProductGroupsRes() {
    return {
        type: actionCreator(ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS, 'res'),
        ids: [],
    };
}

export function bulkCheckedProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS, 'err'),
    };
}
// B U L K   P R O D U C T   G R O U P S   P R O D U C T S  G R O U P S


// A D D   N E W   P R O D U C T   G R O U P S
export function addNewProductGroups(data) {
    return {
        type: ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS,
        data,
    };
}

export function addNewProductGroupsRes(loading, success) {
    return {
        type: actionCreator(ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS, 'res'),
        loading,
        success,
    };
}

export function addNewProductGroupsErr(error) {
    return {
        type: actionCreator(ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS, 'err'),
        error,
    };
}

export function goToStepOfProductGroupsForm(step, propertyID) {
    return {
        type: ProductGroupTypes.GO_TO_STEP_OF_PRODUCT_GROUPS_FORM,
        step,
        propertyID,
    };
}
// A D D   N E W   P R O D U C T   G R O U P S


// U P D A T E   T R A N S L A T E   P R O P R I E T Y
export function updateTranslateProductGroups() {
    return {
        type: ProductGroupTypes.UPDATE_TRANSLATE_PRODUCT_GROUPS,
    };
}

export function updateTranslateProductGroupsRes(key, loading, success) {
    return {
        type: actionCreator(ProductGroupTypes.UPDATE_TRANSLATE_PRODUCT_GROUPS, 'res'),
        key,
        loading,
        success,
    };
}
// U P D A T E   T R A N S L A T E   P R O P R I E T Y


// L O A D   E D I T A B L E   P R O D U C T   G R O U P S
export function loadEditableProductGroups(id, packages = false, properties = false) {
    return {
        type: ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS,
        id,
        packages,
        properties,
    };
}

export function loadEditableProductGroupsRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS, 'res'),
        data,
    };
}

export function loadEditableProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS, 'err'),
    };
}

export function setEmptyEditableProductGroups() {
    return {
        type: ProductGroupTypes.SET_EMPTY_EDITABLE_PRODUCT_GROUPS,
    };
}
// L O A D   E D I T A B L E   P R O D U C T   G R O U P S


// L O A D   E D I T A B L E   P A C K A G E S   F R O M   P R O D U C T   G R O U P S
export function loadEdiTablePackagesFromProductGroups(ids) {
    return {
        type: ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS,
        ids,
    };
}

export function loadEdiTablePackagesFromProductGroupsRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS, 'res'),
        data,
    };
}

export function loadEdiTablePackagesFromProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS, 'err'),
    };
}

export function loadDisplayUsersForAttachedPackages(data) {
    return {
        type: ProductGroupTypes.LOAD_DISPLAY_USERS_FOR_ATTACHED_PACKAGES,
        data,
    };
}
// L O A D   E D I T A B L E   P A C K A G E S   F R O M   P R O D U C T   G R O U P S


// E D I T   P R O D U C T   G R O U P S
export function editProductGroups(data) {
    return {
        type: ProductGroupTypes.EDIT_PRODUCT_GROUPS,
        data,
    };
}

export function editProductGroupsRes(loading, success) {
    return {
        type: actionCreator(ProductGroupTypes.EDIT_PRODUCT_GROUPS, 'res'),
        loading,
        success,
    };
}

export function editProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.EDIT_PRODUCT_GROUPS, 'err'),
    };
}
// E D I T   P R O D U C T   G R O U P S


// L O A D   S E L L   P R I C E
export function loadSellPrices(payload) {
    return {
        type: ProductGroupTypes.LOAD_SELL_PRICE,
        payload,
    };
}

export function loadSellPricesRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_SELL_PRICE, 'res'),
        data,
    };
}

export function loadSellPricesErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_SELL_PRICE, 'err'),
    };
}
// L O A D   S E L L   P R I C E


// L O A D   R E S E L L E R S   F O R   S E L L   P R I C E
export function setResellerForSellPrice(id) {
    return {
        type: ProductGroupTypes.SET_RESELLER_FOR_SELL_PRICE,
        id,
    };
}
// L O A D   R E S E L L E R S   F O R   S E L L   P R I C E


// L O A D   P R O D U C T   G R O U P
export function loadProductGroupForSellPrice() {
    return {
        type: ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE,
    };
}

export function loadProductGroupForSellPriceRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE, 'res'),
        data,
    };
}

export function loadProductGroupForSellPriceErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE, 'err'),
    };
}

export function setEmptyProductGroupFromSellPrice() {
    return {
        type: ProductGroupTypes.SET_EMPTY_PRODUCT_GROUP_FROM_SELL_PRICE,
    };
}
// L O A D   P R O D U C T   G R O U P


// U P D A T E   S E L L   P R I C E
export function updateSellPrice(data) {
    return {
        type: ProductGroupTypes.UPDATE_SELL_PRICE,
        data,
    };
}

export function updateSellPriceRes(payload) {
    return {
        type: actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'res'),
        payload,
    };
}

export function updateSellPriceReq(payload) {
    return {
        type: actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'req'),
        payload,
    };
}

export function updateSellPriceErr() {
    return {
        type: actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'err'),
    };
}
// U P D A T E   S E L L   P R I C E


// T O G G L E   C O S T   S T A T U S   B Y   S E L L   P R I C E
export function setCheckedSellPrice(ids) {
    return {
        type: ProductGroupTypes.SET_CHECKED_SELL_PRICE,
        ids,
    };
}

export function toggleCostStatusBySellPrice(ids, status) {
    return {
        type: ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE,
        ids,
        status,
    };
}

export function toggleCostStatusBySellPriceRes() {
    return {
        type: actionCreator(ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE, 'res'),
    };
}

export function toggleCostStatusBySellPriceErr() {
    return {
        type: actionCreator(ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE, 'err'),
    };
}
// T O G G L E   C O S T   S T A T U S   B Y   S E L L   P R I C E


// S E L L   P R I C E   F I L T E R S,   P A G I N A T I O N ,   S O R T   &   R E S E T
export function setSellPricePagination(key, value) {
    return {
        type: ProductGroupTypes.SET_SELL_PRICE_PAGINATION,
        key,
        value,
    };
}

export function setSellPriceFilters(key, value) {
    return {
        type: ProductGroupTypes.SET_SELL_PRICE_FILTERS,
        key,
        value,
    };
}

export function setSellPriceFiltersRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.SET_SELL_PRICE_FILTERS, 'res'),
        data,
    };
}

export function setSellPriceSort(sort) {
    return {
        type: ProductGroupTypes.SET_SELL_PRICE_SORT,
        sort,
    };
}

export function resetSellPriceFilters() {
    return {
        type: ProductGroupTypes.RESET_SELL_PRICE_FILTERS,
    };
}
// S E L L   P R I C E   F I L T E R S,   P A G I N A T I O N ,   S O R T   &   R E S E T


// A D D   B U L K   P A C K A G E S
export function updatePackageToListProductGroups(payload, id, data) {
    return {
        type: ProductGroupTypes.UPDATE_PACKAGES_TO_LIST_PRODUCT_GROUPS,
        payload,
        id,
        data,
    };
}

export function addBulkPackagesForProductGroups(data) {
    return {
        type: ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS,
        data,
    };
}

export function addBulkPackagesForProductGroupsRes() {
    return {
        type: actionCreator(ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'res'),
    };
}

export function addBulkPackagesForProductGroupsErr(error) {
    return {
        type: actionCreator(ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'err'),
        error,
    };
}
// A D D   B U L K   P A C K A G E S


// D E L E T E    B U L K   P A C K A G E S
export function deleteBulkPackagesForProductGroups(data) {
    return {
        type: ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS,
        data,
    };
}

export function deleteBulkPackagesForProductGroupsRes() {
    return {
        type: actionCreator(ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'res'),
    };
}

export function deleteBulkPackagesForProductGroupsErr(error) {
    return {
        type: actionCreator(ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'err'),
        error,
    };
}
// D E L E T E    B U L K   P A C K A G E S


// R E S E T   P A C K A G E   F R O M    P R O D U C T   G R O U P S
export function resetPackageFromProductGroups(prop) {
    return {
        type: ProductGroupTypes.RESET_PACKAGE_FROM_PRODUCT_GROUPS,
        prop,
    };
}

export function resetChosenPackagesPaginationFromProductGroup() {
    return {
        type: ProductGroupTypes.RESET_CHOSEN_PACKAGES_PAGINATION_FROM_PRODUCT_GROUP,
    };
}
// R E S E T   P A C K A G E   F R O M    P R O D U C T   G R O U P S


// L O A D   P A C K A G E S   F O R   P R O D U C T   G R O U P S
export function loadPackagesForProductGroups() {
    return {
        type: ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS,
    };
}

export function loadPackagesForProductGroupsRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS, 'res'),
        data,
    };
}

export function loadPackagesForProductGroupsErr() {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS, 'err'),
    };
}
// L O A D   P A C K A G E S   F O R   P R O D U C T   G R O U P S


// L O A D   U S E R S   F O R   P A C K A G E
export function loadUsersForPackage(name) {
    return {
        type: ProductGroupTypes.LOAD_USERS_FOR_PACKAGE,
        name,
    };
}

export function loadUsersForPackageRes(data) {
    return {
        type: actionCreator(ProductGroupTypes.LOAD_USERS_FOR_PACKAGE, 'res'),
        data,
    };
}
// L O A D   U S E R S   F O R   P A C K A G E


// S E T   C H E C K E D   P A C K A G E S   F O R   P R O D U C T   G R O U P S
export function setCheckedPackagesForProductGroups(prop, ids) {
    return {
        type: ProductGroupTypes.SET_CHECKED_PACKAGES_FOR_PRODUCT_GROUPS,
        prop,
        ids,
    };
}
// S E T   C H E C K E D   P A C K A G E S   F O R   P R O D U C T   G R O U P S


// S E T   P A C K A G E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   P R O D U C T   G R O U P S
export function setPackagesFiltersForProductGroup(key, value) {
    return {
        type: ProductGroupTypes.SET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP,
        key,
        value,
    };
}

export function setPackagesPaginationForProductGroup(key, pagination) {
    return {
        type: ProductGroupTypes.SET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP,
        key,
        pagination,
    };
}

export function setPackagesSortForProductGroup(sort) {
    return {
        type: ProductGroupTypes.SET_PACKAGES_SORT_FOR_PRODUCT_GROUP,
        sort,
    };
}

export function resetPackagesFiltersForProductGroup(prop) {
    return {
        type: ProductGroupTypes.RESET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP,
        prop,
    };
}

export function resetPackagesPaginationForProductGroup() {
    return {
        type: ProductGroupTypes.RESET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP,
    };
}

export function setChosenPackageFiltersForProductGroup(key, value) {
    return {
        type: ProductGroupTypes.SET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP,
        key,
        value,
    };
}

export function setChosenPackagesSortForProductGroup(sort) {
    return {
        type: ProductGroupTypes.SET_CHOSEN_PACKAGES_SORT_FOR_PRODUCT_GROUP,
        sort,
    };
}

export function setChosenPackagesPaginationForProductGroup(key, pagination) {
    return {
        type: ProductGroupTypes.SET_CHOSEN_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP,
        key,
        pagination,
    };
}

export function resetChosenPackagesFiltersForProductGroup() {
    return {
        type: ProductGroupTypes.RESET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP,
    };
}
// S E T   P A C K A G E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   P R O D U C T   G R O U P S
